import CardForm from './src'

CardForm.install = Vue => {
  Vue.component(CardForm.name, CardForm)
}

export default CardForm
